import { CamelRequestError } from '@onestep/camel-api';
import { isAxiosError } from 'axios';

export const httpStatusOf = (error: unknown): number | undefined => {
  if (error instanceof CamelRequestError) return error.status;
  return isAxiosError(error) ? error.response?.status : undefined;
};

export const isClientTimeout = (error: unknown): boolean =>
  isAxiosError(error) && (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT');
